import { render, staticRenderFns } from "./nominationForm.vue?vue&type=template&id=14b6db0c&"
import script from "./nominationForm.vue?vue&type=script&lang=js&"
export * from "./nominationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports